import { createContext, useContext } from 'react';
import { LinkProps } from '../../lib/Link/Link';
import {
  CookiesSettings,
  CookiesPopup,
} from 'libs/common-kontent-client/src/models/PLAYER_PORTALS';

export type PlayerPortalsChampionship = {
  name: string;
  landingPageLink?: LinkProps;
  kontentCollection?: string;
  championshipIdentifier?: string;
  website: string;
};

export type PlayerPortalsSiteSettings = {
  cookiesSettings: CookiesSettings | undefined;
  cookiesPopup: CookiesPopup | undefined;
  playerPortals: {
    availableChampionships?: PlayerPortalsChampionship[];
  };
  qualifyingPortal: {
    landingPageLink?: string;
  };
};

export type PlayerPortalsConfigContextType = {
  currentChampionship?: PlayerPortalsChampionship;
  siteSettings?: PlayerPortalsSiteSettings;
  methods: {
    setCurrentChampionship: (championship?: PlayerPortalsChampionship) => void;
  };
};

export const PlayerPortalsConfigContext = createContext<
  PlayerPortalsConfigContextType | undefined
>(undefined);

export const usePlayerPortalsConfigContext = () => {
  const context = useContext(PlayerPortalsConfigContext);

  if (!context) {
    throw new Error(
      'PlayerPortalsConfigContext must be used within an PlayerPortalsConfig Provider',
    );
  }

  return context;
};
